"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixContentEditableDOM = fixContentEditableDOM;
exports.getClosestAttribute = void 0;
exports.getFirstEndNode = getFirstEndNode;
exports.getLastEndNode = getLastEndNode;
exports.getMostOuterContainer = getMostOuterContainer;
exports.getNextNode = getNextNode;
exports.isElement = isElement;
exports.traverse = exports.removeLinebreaks = exports.placeCaretAtEnd = void 0;
exports.unwrap = unwrap;
exports.updateTextWrapper = exports.updatePastedTextNode = void 0;
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function isElement(o) {
  return (typeof HTMLElement === "undefined" ? "undefined" : _typeof(HTMLElement)) === 'object' ? o instanceof HTMLElement : o && _typeof(o) === 'object' && o !== null && o.nodeType === 1 && typeof o.nodeName === 'string';
}
function getMostOuterContainer(node, rootElement) {
  if (!(node instanceof Node) || !(rootElement instanceof Node)) {
    throw new Error('The given argument must be an instance of Node!');
  }
  if (node.parentNode && node.parentNode !== rootElement) {
    return getMostOuterContainer(node.parentNode, rootElement);
  }
  return node;
}
function unwrap(node) {
  if (!(node instanceof Node)) {
    throw new Error('The given argument must be an instance of Node!');
  }
  // get the element's parent node
  var parent = node.parentNode;
  if (parent) {
    // move all children out of the element
    while (node.firstChild) {
      parent.insertBefore(node.firstChild, node);
    }
    // remove the empty element
    parent.removeChild(node);
    return true;
  }
  return false;
}
function getFirstEndNode(node) {
  if (!(node instanceof Node)) {
    throw new Error('The given argument must be an instance of Node!');
  }
  return node.childNodes.length > 0 ? getFirstEndNode(node.childNodes[0]) : node;
}
function getLastEndNode(node) {
  if (!(node instanceof Node)) {
    throw new Error('The given argument must be an instance of Node!');
  }
  var lastChild = node.lastChild;
  return lastChild ? getLastEndNode(lastChild) : node;
}
function getNextNode(node, rootNode) {
  if (!(node instanceof Node) || !(rootNode instanceof Node)) {
    throw new Error('The given argument must be an instance of Node!');
  }
  if (!node || node === rootNode) {
    return false;
  }
  if (node.nextSibling) {
    return getFirstEndNode(node.nextSibling);
  }
  if (node.parentNode) {
    return getNextNode(node.parentNode, rootNode);
  }
  return false;
}
var getClosestAttribute = exports.getClosestAttribute = function getClosestAttribute(node, attributeName) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return node.hasAttribute && node.hasAttribute(attributeName) ? node.getAttribute(attributeName) : node.parentNode ? getClosestAttribute(node.parentNode, attributeName) : defaultValue;
};
var placeCaretAtEnd = exports.placeCaretAtEnd = function placeCaretAtEnd(el) {
  el.focus();
  if (typeof window.getSelection !== 'undefined' && typeof document.createRange !== 'undefined') {
    var range = document.createRange();
    range.selectNodeContents(el);
    range.collapse(false);
    var sel = window.getSelection();
    if (sel) {
      sel.removeAllRanges();
      sel.addRange(range);
    }
  }
};
var updatePastedTextNode = exports.updatePastedTextNode = function updatePastedTextNode(rootNode, disableLinebreaks) {
  var divs = rootNode.childNodes;
  if (disableLinebreaks) {
    removeLinebreaks(rootNode);
  } else {
    var _iterator = _createForOfIteratorHelper(divs),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var child = _step.value;
        // get the text nodes and wrap it in Div and span in order to apply styles
        var text = child.textContent || '';
        if (child.nodeType === Node.TEXT_NODE) {
          if ((text.match(/\n/g) || []).length) {
            // To support multi line
            var textElements = text.split('\n');
            var _iterator2 = _createForOfIteratorHelper(textElements),
              _step2;
            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var element = _step2.value;
                var textWrapper = document.createElement('span');
                var wrapperDiv = document.createElement('div');
                textWrapper.innerText = element.trim();
                wrapperDiv.appendChild(textWrapper);
                child.parentNode && child.parentNode.insertBefore(wrapperDiv, child);
                placeCaretAtEnd(textWrapper);
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          } else {
            updateTextWrapper(child);
          }
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
};
var removeLinebreaks = exports.removeLinebreaks = function removeLinebreaks(rootNode) {
  var divs = rootNode.childNodes;
  divs.forEach(function (child, key) {
    if (key !== 0) {
      if (rootNode.firstChild) {
        var parentText = rootNode.firstChild.textContent || '';
        var childText = child.textContent || '';
        rootNode.firstChild.textContent = "".concat(parentText, " ").concat(childText);
      }
      rootNode.removeChild(child);
    }
  });
  if (rootNode && rootNode.textContent) {
    rootNode.textContent = rootNode.textContent.split('\n').join(' ');
  }
};
var updateTextWrapper = exports.updateTextWrapper = function updateTextWrapper(child) {
  var textWrapper = document.createElement('span');
  var wrapperDiv = document.createElement('div');
  textWrapper.innerText = child.textContent ? child.textContent.trim() : '';
  wrapperDiv.appendChild(textWrapper);
  child.replaceWith(wrapperDiv);
  placeCaretAtEnd(wrapperDiv);
};
var traverse = exports.traverse = function traverse(node, cb) {
  cb(node);
  for (var i = 0; i < node.childNodes.length; i++) {
    traverse(node.childNodes[i], cb);
  }
};
function fixContentEditableDOM(rootElement, node) {
  var currentNode = node || rootElement;
  if (!(currentNode instanceof HTMLElement) || !(rootElement instanceof HTMLElement)) {
    throw new Error('The given argument must be an instance of HTMLElement!');
  }
  var _iterator3 = _createForOfIteratorHelper(currentNode.children),
    _step3;
  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var child = _step3.value;
      if (!(child instanceof HTMLElement)) {
        continue;
      }
      if (child.nodeName === 'SPAN') {
        if (child.style.fontSize === '1rem') {
          child.style.fontSize = '';
          if (child.style.length === 0) {
            unwrap(child);
          }
        }
      }
      if (rootElement.childElementCount === 1 && rootElement.firstChild && rootElement.firstChild.nodeName === 'DIV' && rootElement.firstChild.textContent === '') {
        rootElement.firstChild.remove();
      }
      if (child.parentNode !== rootElement) {
        if (child.nodeName === 'DIV' && child.style.length === 0) {
          unwrap(child);
        }
      }
      fixContentEditableDOM(rootElement, child);
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }
}